var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpark = function SvgSpark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 0.583332L10.3483 2.1875L8.75001 2.91667L10.3483 3.65167L11.0833 5.25L11.8125 3.65167L13.4167 2.91667L11.8125 2.1875M5.25001 2.33333L3.79168 5.54167L0.583344 7L3.79168 8.45833L5.25001 11.6667L6.70834 8.45833L9.91668 7L6.70834 5.54167M11.0833 8.75L10.3483 10.3483L8.75001 11.0833L10.3483 11.8125L11.0833 13.4167L11.8125 11.8125L13.4167 11.0833L11.8125 10.3483",
    fill: "url(#badge-gradient-icon)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "badge-gradient-icon",
    x1: 0.583344,
    y1: 0.583332,
    x2: 16.0237,
    y2: 6.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "var(--color-accent-canteloupe-base)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "var(--color-accent-persimmon-base)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "var(--color-accent-plum-base)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "spark.d1eb9e8a05d237e45c40da9b8d096874.svg";